import { StringIndexedDict } from "../../../../api/GenericTypes";
import {
  GenericEntityVirtualizedEntitySelectFormFieldProps,
  GenericVirtualizedEntitySelectFormFieldControllerWrapper,
} from "../../../formfields/GenericVirtualizedSelectFormField/GenericVirtualizedEntitySelectFormFieldControllerWrapper";
import { MethodFilters, MethodSortingOptionsConsts, MethodSuggestions, methodsConstants } from "../../../../api/Method";

export const MethodsVirtualizedSelectForm = <Entity extends StringIndexedDict>(
  props: GenericEntityVirtualizedEntitySelectFormFieldProps<Entity, MethodSuggestions, MethodFilters>
) => {
  return (
    <GenericVirtualizedEntitySelectFormFieldControllerWrapper<Entity, MethodSuggestions, MethodFilters>
      {...props}
      filters={{ sortBy: [{ property: "NAME", sortDirection: "ASC" }], ...props.filters }}
      entityConstants={methodsConstants}
      orderByOptions={MethodSortingOptionsConsts}
      allowCreateEntity={false}
    />
  );
};
